import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { NFCheckBoxInput } from "src/components/Shared/NewForms/NFCheckBoxInput";
import { useTranslation } from "react-i18next";

export const SalesOrdersDetailAdditional = ({}) => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextAreaInput
                        fieldName={"comment"}
                        title={t("Comment")}
                        required={false}
                    />
                </Col>
                <Col sm={6}>
                    <NFCheckBoxInput
                        title={t("PriceIncludesVAT")}
                        fieldName="priceIncludesVat"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("CreatedUser")}
                        fieldName={"createdUser"}
                        disabled={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("CreatedDate")}
                        fieldName={"createdDate"}
                        disabled={true}
                    />
                </Col>
            </Row>
        </>
    );
};
